import React from "react"
import "./BancosProyecto.scss"

const BancosProyecto = () => {
  return (
    <section className="bancos-seccion">
      <div className="bancos-contenido mwx-1680 mx-auto text-center">
        <span className="bancos-label font-lato weight-300">
          Trabajamos con:
        </span>
        <span className="bancos-texto font-roboto weight-bold">
          Todos los bancos
        </span>
      </div>
    </section>
  )
}

export default BancosProyecto
